var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.001,
    height: 400.001,
    viewBox: "0 0 200.001 400.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.118,
    y1: 0.186,
    x2: 0.882,
    y2: 0.814,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff52a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90353"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1174,542h0a201.484,201.484,0,0,1-40.307-4.063,199,199,0,0,1-37.542-11.654,200.037,200.037,0,0,1-33.973-18.44,201.449,201.449,0,0,1-29.6-24.422,201.437,201.437,0,0,1-24.422-29.6,200.008,200.008,0,0,1-18.44-33.973,198.991,198.991,0,0,1-11.654-37.542A201.474,201.474,0,0,1-1374,342a201.473,201.473,0,0,1,4.063-40.307,198.994,198.994,0,0,1,11.654-37.542,200.006,200.006,0,0,1,18.44-33.973,201.437,201.437,0,0,1,24.422-29.6,201.443,201.443,0,0,1,29.6-24.422,200.029,200.029,0,0,1,33.973-18.44,198.994,198.994,0,0,1,37.542-11.654A201.484,201.484,0,0,1-1174,142V542Z",
    transform: "translate(1374 -142)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleLeft);
export default __webpack_public_path__ + "static/media/bubble_left.ed0e8f76f8f687437e0a6c403c27e729.svg";
export { ForwardRef as ReactComponent };